export type ExportLogMetadata = {
  export_option?: string
  export_format?: string
  recipients?: string[]
}

/** Parse the JSONString metadata on an EXPORTED action log. Returns null if absent/invalid. */
export const parseExportLogMetadata = (
  metadata?: string | null
): ExportLogMetadata | null => {
  if (!metadata) return null
  try {
    const parsed = JSON.parse(metadata)
    return typeof parsed === 'object' && parsed !== null ? parsed : null
  } catch {
    return null
  }
}
